export const FuelCardTypes = Object.freeze({
    "LIMIT": "fuel_card_limit",
    "DUPLICATE": "fuel_card_duplicate",
    "INACTIVE": "INACTIVE",
    })